
import * as languageSupport from '../src/languageSupport';
import * as languages from '../src/languages';

export {
  languageSupport,
  languages
}
